import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/AuthContext";

import Landing from "@/pages/Landing";
import FreeWebsiteAudit from "@/pages/FreeWebsiteAudit";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Overview from "@/pages/admin/Overview";
import CRM from "@/pages/admin/CRM";
import LeadProfile from "@/pages/admin/LeadProfile";
import Settings from "@/pages/admin/Settings";
import LeadGenerator from "@/pages/admin/LeadGenerator";
import Pipeline from "@/pages/admin/Pipeline";
import ComingSoon from "@/pages/admin/ComingSoon";
import ProtectedRoute from "@/components/admin/ProtectedRoute";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/free-website-audit" element={<FreeWebsiteAudit />} />

            <Route path="/admin" element={<AdminLogin />} />
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Overview />} />
              <Route
                path="lead-generator"
                element={<LeadGenerator />}
              />
              <Route path="leads" element={<CRM />} />
              <Route path="leads/:id" element={<LeadProfile />} />
              <Route path="pipeline" element={<Pipeline />} />
              <Route
                path="follow-ups"
                element={
                  <ComingSoon
                    testid="phase3-follow-ups"
                    title="Follow-Ups"
                    phase={3}
                    description="Follow-ups due today, this week, overdue, and drafts waiting for your review — with in-dashboard notifications."
                  />
                }
              />
              <Route
                path="website-audits"
                element={
                  <ComingSoon
                    testid="phase3-audits"
                    title="Website Audits"
                    phase={3}
                    description="Generate professional Almonte Sites audits with Google PageSpeed data, edit them, and export a client-friendly PDF."
                  />
                }
              />
              <Route
                path="analytics"
                element={
                  <ComingSoon
                    testid="phase3-analytics"
                    title="Analytics"
                    phase={3}
                    description="Date-filtered performance: leads generated, contacted, converted, best niches, best sources, pipeline revenue."
                  />
                }
              />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>

      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#171717",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#fff",
          },
        }}
      />
    </div>
  );
}

export default App;
